export default __webpack_public_path__ + "static/media/chameleons.e3a75c47.png";